// Runtime configuration support - loads from window.REACT_APP_CONFIG if available
// Falls back to build-time environment variables for development
const getConfigValue = (key: string, defaultValue?: string): string | undefined => {
	// Check runtime config first (for production deployments)
	if (typeof window !== 'undefined' && (window as any).REACT_APP_CONFIG) {
		const runtimeValue = (window as any).REACT_APP_CONFIG[key];
		if (runtimeValue && runtimeValue !== `__${key}__`) {
			return runtimeValue;
		}
	}
	// Fallback to build-time env vars (for development)
	return process.env[key] || defaultValue;
};

export const rawApiUrl = getConfigValue('REACT_APP_DEV_BACK_END_BASE_URL');
export const BuildType = getConfigValue('REACT_APP_BUILD_TYPE', 'production');

export const ApiURL =
	rawApiUrl && rawApiUrl.includes('https://') ? rawApiUrl : `https://${rawApiUrl}`;
export const isProductionBuild = BuildType === 'production';